export default function  metaTag(color){
    document.querySelector("[name='theme-color']").remove()
    let meta = document.createElement('meta');
    meta.name = "theme-color";
    meta.content = color;
    document.getElementsByTagName('head')[0].appendChild(meta);
}
